import React, { useState } from "react";
import { Card, Collapse, Input, Button, Space } from "antd";
import { SearchOutlined, EditOutlined } from "@ant-design/icons";
import LoadingSpinner from "../common/loading";
import { useToast } from "../common/toast";
import useApiCall from "../common/api-call";
import { Tag } from "antd";
import { useHistory } from "react-router-dom";
import theme from "../theme";

const { Panel } = Collapse;

const PremadeSearchView = () => {
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [premades, setPremades] = useState([]);
  const { successToast, errorToast } = useToast();
  const { apiCall } = useApiCall();
  const history = useHistory();

  const handleSearch = async () => {
    if (!searchText.trim()) {
      setPremades([]);
      return;
    }

    setLoading(true);
    try {
      const request = { searchText: searchText };
      const response = await apiCall("/premade/search", "POST", request);

      if (response && !response.error) {
        setPremades(response.premades || []);
      } else {
        throw new Error(response?.error || "Unknown error");
      }
    } catch (error) {
      errorToast("Error searching premades! Please retry.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleEditPremade = premadeId => {
    history.push(`/premade/script?id=${premadeId}`);
  };

  const renderPremadeContent = premade => {
    return (
      <div style={{ marginTop: 8 }}>
        <Space direction="vertical" size="small" style={{ marginBottom: 16, width: "100%" }}>
          <div style={{ fontSize: "0.875rem", color: theme.palette.text.secondary }}>
            Version:{" "}
            <span style={{ color: theme.palette.primary.main }}>
              {premade.version}
            </span>
          </div>
          <div style={{ fontSize: "0.875rem", color: theme.palette.text.secondary }}>
            Creator:{" "}
            <span style={{ color: theme.palette.primary.main }}>
              {premade.creator}
            </span>
          </div>
        </Space>

        <div style={{ fontSize: "0.875rem", color: theme.palette.text.secondary }}>
          Description:
        </div>
        <div style={{ marginLeft: 16, marginBottom: 16, fontSize: "0.875rem" }}>
          {premade.description || "No description available"}
        </div>

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => handleEditPremade(premade.id)}
            size="small"
          />
        </div>
      </div>
    );
  };

  return (
    <div style={{ flexGrow: 1 }}>
      <div style={{ padding: "8px 16px" }}>
        <form
          onSubmit={e => {
            e.preventDefault();
            handleSearch();
          }}
          style={{
            padding: 0,
            display: "flex",
            alignItems: "center",
            width: "100%",
            marginBottom: 8,
            backgroundColor: theme.palette.background.card,
            borderRadius: 4,
            border: "1px solid #d9d9d9",
            overflow: "hidden",
          }}
        >
          <Input
            style={{ 
              flex: 1,
              border: "none",
              boxShadow: "none",
              height: "40px",
              fontSize: "14px",
            }}
            placeholder="Search premades..."
            value={searchText}
            onChange={e => setSearchText(e.target.value)}
            onPressEnter={handleSearch}
            suffix={
              <Button
                type="text"
                icon={<SearchOutlined />}
                onClick={handleSearch}
                style={{ border: "none" }}
              />
            }
          />
        </form>
      </div>

      {loading ? (
        <LoadingSpinner />
      ) : (
        <div style={{ padding: "0 16px" }}>
          {premades.length > 0 ? (
          <Collapse
            style={{
              backgroundColor: theme.palette.background.card,
            }}
          >
            {premades.map((premade, index) => (
              <Panel
                key={index}
                style={{
                  backgroundColor: theme.palette.background.card,
                }}
                header={
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div>
                      <div style={{ fontSize: "1rem", fontWeight: 500 }}>
                        {premade.id}
                      </div>
                      <div style={{ fontSize: "0.875rem", color: theme.palette.text.secondary }}>
                        {premade.summary}
                      </div>
                    </div>
                    <div>
                      {premade.status && (
                        <Tag
                          color={
                            premade.status === "PUBLISHED" ? "green" : "default"
                          }
                          style={{ marginRight: 8 }}
                        >
                          {premade.status}
                        </Tag>
                      )}
                      {premade.archived && (
                        <Tag color="default">Archived</Tag>
                      )}
                    </div>
                  </div>
                }
              >
                {renderPremadeContent(premade)}
              </Panel>
            ))}
          </Collapse>
          ) : (
            <Card style={{ padding: 24, textAlign: "center" }}>
              <div style={{ 
                fontSize: "1rem", 
                color: theme.palette.text.secondary
              }}>
                {searchText.trim() === "" 
                  ? "No data. Please enter a search term to find premades."
                  : "No data found"}
              </div>
            </Card>
          )}
        </div>
      )}
    </div>
  );
};

export default PremadeSearchView;
